import { render, staticRenderFns } from "./RulePharse.vue?vue&type=template&id=7d2b54da&scoped=true&"
import script from "./RulePharse.vue?vue&type=script&lang=ts&"
export * from "./RulePharse.vue?vue&type=script&lang=ts&"
import style0 from "./RulePharse.vue?vue&type=style&index=0&id=7d2b54da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2b54da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
